import React from 'react';
import { ProgressIndicator, ProgressStep } from 'carbon-components-react';

const ProgressIndicatorHorizontal: React.FC<Props> = ({ currentStep }) => {
  let stepIndex = currentStep - 1;
  if (currentStep === 4) {
    stepIndex = 2;
  }
  return (
    <div id="progressSection" className="progress-section-container">
      <div id="progressIndicator" className="progress-indicator-wrapper">
        <ProgressIndicator
          currentIndex={stepIndex}
          vertical={false}
          spaceEqually={true}
        >
          <ProgressStep label="Profile" />
          <ProgressStep label="BYDA Details" />
          <ProgressStep label="Authorisation" />
        </ProgressIndicator>
      </div>
    </div>
  );
};

type Props = {
  currentStep: number;
};

export default React.memo(ProgressIndicatorHorizontal);
